import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { BOB_JOBBER_ARROW_BOTTOM } from './V2L1BobJobber'

const V2L2BobJobberContextRoot = styled.div({
	position: 'relative',
})

const JobberContainer = styled.div({
	position: 'absolute',
	top: `calc(-1rem + ${BOB_JOBBER_ARROW_BOTTOM}px)`,
	left: '50%',
	transform: 'translate(-50%, -100%)',
})

interface V2L2BobJobberContextProps {
	jobber?: ReactNode
	children?: ReactNode
}

export const V2L2BobJobberContext = ({jobber, children}: V2L2BobJobberContextProps) => {
	return (
		<V2L2BobJobberContextRoot>
			{children}
			{jobber ? (
				<JobberContainer>
					{jobber}
				</JobberContainer>
			) : null}
		</V2L2BobJobberContextRoot>
	)
}
